import PasscodeBubbles from 'components/passcode/PasscodeBubbles';
import PasscodeDigits from 'components/passcode/PasscodeDigits';
import PasscodeKeypad from 'components/passcode/PasscodeKeypad';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

export const PASSCODE_LENGTH = 4;

interface Props {
  passcode: string;
  showDigits?: boolean;
  onPasscodeChanged(passcode: string): void;
  error?: boolean;
}

export default class PasscodeInput extends PureBaseComponent<Props> {
  addToPasscode(digit: string) {
    const passcode = this.props.passcode;
    if (passcode.length < PASSCODE_LENGTH) {
      this.props.onPasscodeChanged(passcode + digit);
    }
  }

  clearPasscode() {
    this.props.onPasscodeChanged('');
  }

  backspacePasscode() {
    const passcode = this.props.passcode;
    this.props.onPasscodeChanged(passcode.substring(0, passcode.length - 1));
  }

  render() {
    const { passcode, showDigits, error } = this.props;

    return (
      <div className="PasscodeInput">
        <div className="PasscodeInput-display">
          {showDigits ? (
            <PasscodeDigits passcode={passcode} maxLength={PASSCODE_LENGTH} error={error} />
          ) : (
            <PasscodeBubbles passcode={passcode} maxLength={PASSCODE_LENGTH} />
          )}
        </div>
        <div className="PasscodeInput-keypad">
          <PasscodeKeypad
            onDigitEntered={this.addToPasscode}
            onClear={this.clearPasscode}
            onBackspace={this.backspacePasscode}
          />
        </div>
      </div>
    );
  }
}
